module.exports = require("npm:marked@0.3.5/lib/marked.js");